import { Component, inject, signal } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppShellComponent, FrameworkService, TenantManagementStubService, XappCapHandlerService } from '@optima-stride-ai/optima-app-framework';
import { DefaultModalComponent } from '../components/modal 2/modal-component/modal.component';
import { IconSetService } from '@coreui/icons-angular';
import { hayagrivaTenants } from '../../assets/tenants';
import { QueryParams, QueryParamValues } from '../../enum/query-params';
import { OffCanvasCollectiveComponent } from "../off-canvas/off-canvas-form/off-canvas-collective/off-canvas-collective.component";
import { Routes as AppRoutes } from '../shared/enums/app-constants';

@Component({
  selector: 'app-application-shell',
  imports: [AppShellComponent, DefaultModalComponent, OffCanvasCollectiveComponent],
  templateUrl: './application-shell.component.html',
  styleUrl: './application-shell.component.sass',
})
export class ApplicationShellComponent {
  protected readonly title = signal('hayagriva');
  protected readonly isOpen = signal(false);
  protected readonly id = signal<number | null>(null);

  private readonly tenantService: TenantManagementStubService = inject(TenantManagementStubService);
  public readonly frameworkService : FrameworkService = inject(FrameworkService);
  private readonly iconSetService: IconSetService = inject(IconSetService);

  get isReady(): boolean {
    return this.frameworkService.currentApp !== null;
  }

  constructor(
  private xappCapHandler: XappCapHandlerService,
  private route: ActivatedRoute,
  private router: Router
) {}

  ngOnInit(): void {
    this.initiazlizeTenants();

    // Get xappCap from URL if present
    const urlParam = this.route.snapshot.queryParamMap.get('xappCap') || undefined;
    
    // Check localStorage first (post-reload), then URL param
    const xappCapResponse = this.xappCapHandler.initFromXappCap(urlParam);
    if (xappCapResponse) {
      if (xappCapResponse.isOpen) {
        // Navigate to existing entity
        const queryParams: any = {
          [QueryParams.OPEN_FILE]: QueryParamValues.TRUE,
          [QueryParams.BIZ_ENTITY_ID]: xappCapResponse.id,
          xappCap: this.xappCapHandler.encodeXappCapResponse(xappCapResponse)
        };
        //     this.router.navigate(['/libraries'],
        
        const isEmbed = 'isEmbed' in xappCapResponse && xappCapResponse.isEmbed === true;
        this.router.navigate([isEmbed ? AppRoutes.EMBED : '/libraries'], {
          queryParams: queryParams,
          replaceUrl: true
        });
      } else if (xappCapResponse.isNew) {
        // Navigate to create new entity with typeId
        const queryParams: any = {
          [QueryParams.ADD_NEW]: QueryParamValues.TRUE
        };
        
        if (xappCapResponse.typeId) {
          queryParams[QueryParams.TYPE_ID] = xappCapResponse.typeId;
        }
        
        if (xappCapResponse.parentId) {
          queryParams[QueryParams.PARENT_ID] = xappCapResponse.parentId;
        }
        
        this.router.navigate(['/libraries'], {
          queryParams: queryParams,
          replaceUrl: true
        });
      }
    } else {
      // Fallback: redirect to dashboard if at root
      const currentUrl = this.router.url;
      if (currentUrl === '/' || currentUrl === '') {
        this.router.navigate(['/dashboard'], { replaceUrl: true });
      }
    }
  }

  private initiazlizeTenants(): void {
    this.tenantService.setTenants(hayagrivaTenants);
  }
}
